<template>
	<div v-show="showFlag">
		<payHeader :bgStatus="bgStatus"></payHeader>
		<div class="user-repwd appeal-form">
			<div class="container">
				<div class="head">
					<h1>账号申诉</h1>
					<ul>
						<li class="step1 active">验证账号</li>
						<li class="step2 active">实名认证</li>
						<li class="step3 active">申诉资料</li>
						<li class="step4">等待审核</li>
					</ul>
				</div>
				<el-form :inline="true" :model="groupForm">
					<el-card class="box-card">
						<template #header>
						  <div class="card-header">
							充值历史<el-text type="warning">（必须为30天前充值记录）</el-text>
							<el-text type="info" style="float: right;">最多新增5条，输入更多准确的信息，可帮助您提高申诉的成功率</el-text>
						  </div>
						</template>
						<div class="server" v-for="(item, index) in groupForm.history" :key="index">
							<el-form-item label="充值方式">
								<el-select v-model="item.pay">
									<el-option label="支付宝" value="zfb" />
									<el-option label="微信" value="wx" />
									<el-option label="网银" value="wy" />
								</el-select>
							</el-form-item>
							<el-form-item label="交易单号">
								<el-input v-model="item.number" placeholder="交易单号" />
							</el-form-item>
							<el-button :icon="Minus" @click.prevent="removeHistory(item)" v-if="index > 0"></el-button>
							<el-button :icon="Plus" @click="addHistory" type="primary" v-if="index == 0"></el-button>
						</div>
					</el-card>
					<el-card class="box-card">
						<template #header>
						  <div class="card-header">
							业务历史
							<el-text type="info" style="float: right;">最多新增5条，输入更多准确的信息，可帮助您提高申诉的成功率</el-text>
						  </div>
						</template>
						<div class="server" v-for="(item, index) in groupForm.bussiness" :key="index">
							<el-form-item label="业务类型">
								<el-select v-model="item.type">
									<el-option label="服务器租用托管" value="服务器租用托管" />
									<el-option label="云服务器" value="云服务器" />
									<el-option label="虚拟主机" value="虚拟主机" />
								</el-select>
							</el-form-item>
							<el-form-item label="时间">
								<el-input v-model="item.time" placeholder="时间" style="width: 233px !important;" />
							</el-form-item>
							<el-form-item label="业务余额">
								<el-input v-model="item.money" placeholder="业务余额" style="width: 200px !important;" />
							</el-form-item>
							<el-button :icon="Minus" @click.prevent="removeBusiness(item)" v-if="index > 0"></el-button>
							<el-button :icon="Plus" @click="addBusiness" type="primary" v-if="index == 0"></el-button>
						</div>
					</el-card>
					<el-card class="box-card">
						<template #header>
						  <div class="card-header">
							历史登录地点
							<el-text type="info" style="float: right;">最多新增3条，输入更多准确的信息，可帮助您提高申诉的成功率</el-text>
						  </div>
						</template>
						<div class="server" v-for="(item, index) in groupForm.login_address" :key="index">
							<el-form-item label="登录地点">
								<el-input v-model="item.ads" placeholder="登录地点" />
							</el-form-item>
							<el-button :icon="Minus" @click.prevent="removeAds(item)" v-if="index > 0"></el-button>
							<el-button :icon="Plus" @click="addAds" type="primary" v-if="index == 0"></el-button>
						</div>
					</el-card>
					<el-card class="box-card">
						<template #header>
						  <div class="card-header">
							其他凭证
							<el-text type="info" style="float: right;">请提交比如和我司通话记录、和我司业务员对接QQ、微信聊天记录等相关能证明的材料</el-text>
						  </div>
						</template>
						<el-form-item label="上传附件" prop="pic">
							<el-upload
								class="avatar-uploader"
								action="#"
								list-type="picture-card"
								:limit="1"
								:http-request="uploadPic"
								:before-upload="beforePicUpload"
							>
								<el-button type="primary" plain>上传文件</el-button>
								<template #tip>
									<div class="el-upload__tip">温馨提示：仅支持格式jpg,png,jpeg图片</div>
								</template>
							</el-upload>
						</el-form-item>
					</el-card>
					<el-button type="primary" size="large" style="margin-left: 48px;" @click="submitForm">确定提交</el-button>
				</el-form>
			</div>
		</div>
		<payFooter></payFooter>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { lduploadfile } from '@/api/common';
	import { appealStep,appealInfo } from '@/api/home';
	import { Plus,Minus } from '@element-plus/icons-vue';
	import { ElMessage } from 'element-plus';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const router = useRouter();
	const showFlag = ref(false);
	const userId = ref('');
	const account = ref('');
	const groupForm = ref(
		{
			history: [{
				pay:'zfb',
				number: ''
			}],
			bussiness:[{
				type:'服务器租用托管',
				time: '',
				money: ''
			}],
			login_address:[{
				ads: '',
			}],
			pic:''
		}
	)
	
	const appealStepF = () => {
		appealStep().then((res) => {
			if (res.code == 200) {
				switch(res.data.step)
				{
					case 0:
						router.push({ path: '/appeal' })
					break;
					case 1:
						router.push({ path: '/appealAuth' })
					break;
					case 2:
						showFlag.value = true;
					break;
					case 3:
						router.push({ path: '/appealStatus' })
					break;
				}
			}
		})
	}
	const addHistory = () => {
		if (groupForm.value.history.length > 4) {
			ElMessage({
				offset: 70,
				message: '充值历史信息最多新增5条',
				type: 'warning'
			})
			return
		}else{
			groupForm.value.history.push({
				pay:'zfb',
				number: ''
			})
		}
	}
	const addBusiness = () => {
		if (groupForm.value.bussiness.length > 4) {
			ElMessage({
				offset: 70,
				message: '业务历史信息最多新增5条',
				type: 'warning'
			})
			return
		}else{
			groupForm.value.bussiness.push({
				type:'服务器租用托管',
				time: '',
				money: ''
			})
		}
	}
	const addAds = () => {
		if (groupForm.value.login_address.length > 2) {
			ElMessage({
				offset: 70,
				message: '历史登录地点信息最多新增3条',
				type: 'warning'
			})
			return
		}else{
			groupForm.value.login_address.push({
				ads: '',
			})
		}
	}
	const removeHistory = (item) => {
		const index = groupForm.value.history.indexOf(item)
		if (index !== -1) {
			groupForm.value.history.splice(index, 1)
		}
	}
	const removeBusiness = (item) => {
		const index = groupForm.value.bussiness.indexOf(item)
		if (index !== -1) {
			groupForm.value.bussiness.splice(index, 1)
		}
	}
	const removeAds = (item) => {
		const index = groupForm.value.login_address.indexOf(item)
		if (index !== -1) {
			groupForm.value.login_address.splice(index, 1)
		}
	}
	const beforePicUpload = (file) => {
		const fileName = file.name;
		const fileType = fileName.substring(fileName.lastIndexOf('.'));
		const isOKType =
			fileType === '.jpg' ||
			fileType === '.png' ||
			fileType === '.jpeg' ||
			fileType === '.bmp' ||
			fileType === '.gif';
			if (!isOKType) {
				ElMessage({
					offset: 70,
					message: '图片格式只能为jpeg/png/jpg',
					type: 'error'
				})
			}
	 
		const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				ElMessage({
					offset: 70,
					message: '图片大小不能超过 2MB!',
					type: 'error'
				})
			}
		return isLt2M && isOKType;
	};
	const uploadPic = (file) => {
		let formData = new FormData();
		const blob = file.file;
		formData.append("type", 1);
		formData.append("file", blob);
		formData.append("cate", 'appeal');
		formData.append("userid", userId.value);
		lduploadfile(formData).then((res) => {
			if (res.code == 200) {
				groupForm.value.pic = res.info.file
			} else{ 
				ElMessage({
					offset: 70,
					message: res.message,
					type: 'error'
				})
			}
		})
	};

	const submitForm = () => {
		if (checkhistoryField(groupForm.value.history)) {
			ElMessage({
				offset: 70,
				message: '请填写充值历史信息',
				type: 'warning'
			})
			return
		}
		if (checkbussinessField(groupForm.value.bussiness)) {
			ElMessage({
				offset: 70,
				message: '请填写业务历史信息',
				type: 'warning'
			})
			return
		}
		if (checkadsField(groupForm.value.login_address)) {
			ElMessage({
				offset: 70,
				message: '请填写登录地点信息',
				type: 'warning'
			})
			return
		}		
		const history = transformData(groupForm.value.history);
		const bussiness = transformData(groupForm.value.bussiness);
		const address = transformLoginAddress(groupForm.value.login_address);
		const param = {
			'account':account.value,
			'bussiness':bussiness,
			'history':history,
			'login_address':address,
			'up-btn':groupForm.value.pic
		}
		appealInfo(param).then((res) => {
			if(res.code === 200){
				router.push({ path: '/appealStatus' })
			}
		})
	};
	const checkhistoryField = (arr) => {
		for (const item of arr) {
			if (!item.number.trim()) {
				return true;
			}
		}
		return false;
	}
	const checkbussinessField = (arr) => {
		for (const item of arr) {
			if (!item.time.trim() || !item.money.trim()) {
				return true;
			}
		}
		return false;
	}
	const checkadsField = (arr) => {
		for (const item of arr) {
			if (!item.ads.trim()) {
				return true;
			}
		}
		return false;
	}
	const transformData = (data) => {
		const result = {};
		data.forEach((item, index) => {
			result[`key${index}`] = item;
		});
		return result;
	};
	const transformLoginAddress = (addresses) => {
	  const result = {};
	  addresses.forEach((item, index) => {
	    result[`key${index}`] = item.ads;
	  });
	  return result;
	};
	
	onMounted(() => {
		account.value = localStorage.getItem('appealAccount');
		userId.value = localStorage.getItem('appealuserId');
		appealStepF()
	})
	
</script>

<style lang="scss" scoped>
	.user-repwd{
		.el-form{
			width: auto;
			margin: 0;
		}
		.head h1{background: url(../../assets/images/appeal_icon.png) no-repeat left center;}
		.box-card{
			margin: 0 48px 24px;
			.server{
				width: 1000px;
				.el-input{display: inline-block; width: 500px !important;}
				.el-select{display: inline-block; width: 200px;}
				.el-button{display: inline-block;vertical-align: text-bottom;}
			}
		}
	}
	::v-deep(.el-input__wrapper) {width: 100% !important;}
</style>